module.exports = __webpack_public_path__ + "img/Mobile_home_img1.cc801529.png";